import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Checkbox } from './ui/checkbox';
import { Play, Activity, Upload } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const NewCrawlForm = () => {
  const { toast } = useToast();
  const [urls, setUrls] = useState('');
  const [profondeur, setProfondeur] = useState('2');
  const [maxPages, setMaxPages] = useState('300');
  const [delayMin, setDelayMin] = useState('6');
  const [delayMax, setDelayMax] = useState('15');
  const [ocr, setOcr] = useState(false);
  const [fileName, setFileName] = useState('Aucun fichier choisi');

  const launch = () => {
    if (!urls.trim()) {
      toast({ title: 'URLs manquantes', description: 'Entrez au moins une URL avant de lancer le crawl.' });
      return;
    }
    toast({ title: 'Crawl lancé 🚀', description: `Profondeur ${profondeur} · Max ${maxPages} pages · Délai ${delayMin}–${delayMax}s` });
  };

  return (
    <section className="space-y-5">
      <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-mono">Nouveau crawl</p>

      <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-6 space-y-5">
        <div>
          <label className="text-xs text-white/70 font-mono mb-2 block">URLs (une par ligne, ou colle plusieurs lignes, ou charge un fichier .txt / .csv)</label>
          <Textarea
            value={urls}
            onChange={(e) => setUrls(e.target.value)}
            placeholder="https://exemple-boutique.fr/categorie/tout"
            className="bg-black/50 border-white/10 text-white font-mono text-sm min-h-[110px] focus-visible:ring-cyan-400/40"
          />
        </div>

        <div>
          <label className="text-xs text-white/70 font-mono mb-2 block">Fichier d'URLs (optionnel)</label>
          <div className="flex items-center gap-3">
            <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-white/10 bg-white/[0.03] text-sm text-white/80 hover:bg-white/[0.06] transition-colors font-mono">
              <Upload className="h-3.5 w-3.5" />
              Choisir un fichier
              <input type="file" className="hidden" accept=".txt,.csv" onChange={(e) => setFileName(e.target.files?.[0]?.name || 'Aucun fichier choisi')} />
            </label>
            <span className="text-sm text-white/50 font-mono truncate">{fileName}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <FieldNum label="Profondeur (liens)" value={profondeur} onChange={setProfondeur} />
          <FieldNum label="Max pages / URL" value={maxPages} onChange={setMaxPages} />
          <FieldNum label="Délai min (s)" value={delayMin} onChange={setDelayMin} />
          <FieldNum label="Délai max (s)" value={delayMax} onChange={setDelayMax} />
        </div>

        <label className="flex items-center gap-3 cursor-pointer group">
          <Checkbox checked={ocr} onCheckedChange={setOcr} className="border-white/30 data-[state=checked]:bg-cyan-500 data-[state=checked]:border-cyan-500" />
          <span className="text-sm text-white/70 group-hover:text-white transition-colors">OCR code-barres en dernier recours si l'EAN est introuvable (plus lent)</span>
        </label>

        <div className="flex flex-wrap items-center gap-3 pt-2">
          <Button onClick={launch} className="h-11 px-8 font-mono uppercase tracking-widest text-xs font-bold text-white bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-400 hover:to-pink-400 shadow-lg shadow-pink-500/25">
            <Play className="h-4 w-4 mr-2" /> Lancer le crawl
          </Button>
          <Button variant="outline" className="h-11 px-6 bg-transparent border-cyan-400/30 text-cyan-300 hover:bg-cyan-400/10 font-mono uppercase text-[11px] tracking-widest">
            <Activity className="h-3.5 w-3.5 mr-2" /> Diagnostic plateforme (scrapfba)
          </Button>
        </div>

        <p className="text-[11px] text-white/40 font-mono flex items-center gap-2">
          <span className="inline-block h-1 w-1 rounded-full bg-cyan-400" />
          Discrétion : un seul site à la fois, délais aléatoires, navigation simulée.
        </p>
      </div>
    </section>
  );
};

const FieldNum = ({ label, value, onChange }) => (
  <div>
    <label className="text-xs text-white/70 font-mono mb-2 block">{label}</label>
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-black/50 border-white/10 text-white font-mono focus-visible:ring-cyan-400/40"
    />
  </div>
);

export default NewCrawlForm;
